import React from "react";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import { exportCSVUseCase } from "../../usecases/csv/usecases";

import withRouter from "../../withRouter";
import BaseListPage from "../../base/BaseListPage";

import JobPortalListPagePresenter from "./JobPortalListPagePresenter";
import Navigation from "../../components/Navigation";

import PortalSearch from "../../components/PortalSearch";
import Card from "../../components/Card";
import { NavLink } from "react-router-dom";
import CustomCheckbox from "../../components/custom-checkbox";
import { signOutUseCase } from "../../usecases/user";

class JobPortalListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new JobPortalListPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase(),
      signOutUseCase()
    );
    this.state = {
      isChecked: false,
      isModalOpen: false,
      objects: [],
      selected: [],
      count: 0,
      progress: false,
      schema: {},
      searchQuery: "",
    };
  }

  getCollectionName() {
    return "job_posting";
  }

  componentDidMount() {
    this.presenter.findObjects();
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setTotal(count) {
    this.setState({ count });
  }

  displayModal(productId) {
    this.setState({ isModalOpen: true, productId });
  }

  closeModal() {
    this.setState({ isModalOpen: false, productId: null });
  }

  onSelect(object) {
    this.setState(
      (prevState) => {
        const isSelected = prevState.selected.some(
          (item) => item.id === object.id
        );

        const updatedSelected = isSelected
          ? prevState.selected.filter((item) => item.id !== object.id)
          : [...prevState.selected, object];

        return {
          selected: updatedSelected,
          isChecked: updatedSelected.length > 0,
        };
      },
      () => {}
    );
  }

  getSelectedItems() {
    return this.state.selected;
  }
  onclickApplyNow() {
    this.presenter.onClickApplyNow();
  }
  onclickDetails() {
    this.presenter.onclickDetails();
  }

  isApplicantWalkIn() {
    return this.props.params.isWalkIn;
  }

  handleSearch = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  logout() {
    this.presenter.onClickSignOut();
  }

  render() {
    const isWalkIn = this.isApplicantWalkIn();
    const { objects, selected, isChecked, searchQuery } = this.state;

    const filteredObjects = objects.filter((object) =>
      object.positionTitle.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // if (true) {
    //   return this.navigateTo("/");
    // }

    return (
      <>
        <Navigation logout={this.logout.bind(this)} />
        <div>
          <div
            className="d-flex flex-column p-5 gap-3 container-fluid justify-content-between"
            style={{ marginTop: `5rem` }}
          >
            <div className="container-fluid w-50 d-flex flex-column text-center">
              <h1 className="fw-bold" style={{ fontSize: `3.5rem` }}>
                YOUR <span style={{ color: `#D18237` }}>CAREER</span> <br />
                IS OUR TOP PRIORITY
              </h1>
            </div>

            <div className="container-fluid col-lg-6 col-md-8">
              <PortalSearch
                schemas={this.getSchemas()}
                onChange={this.handleSearch.bind(this)}
                className="mx-5"
                placeholder="Start your Job Search"
              ></PortalSearch>
            </div>
          </div>
        </div>
        <div className="container-fluid w-100 position-relative">
          <div className="row row-cols-sm-1 row-cols-md-2 row-cols-lg-3 pb-4 px-3">
            {filteredObjects.length > 0 ? (
              filteredObjects.map((object, index) => (
                <div className="col" key={index}>
                  <Card className="py-2 rounded-4 border border-1 bg-white d-flex flex-column overflow-hidden mt-4 w-100">
                    <div className="d-flex justify-content-between gap-3">
                      <div className="d-flex flex-column text-truncate">
                        <h3
                          className="fs-5 fw-bold text-truncate"
                          style={{ color: `#6D9E5F` }}
                        >
                          {object.positionTitle}
                        </h3>

                        <div className="d-flex align-items-center gap-2 py-2">
                          <i
                            className="bi bi-geo-alt-fill fs-4"
                            style={{ color: `#E09552` }}
                          ></i>
                          <p
                            style={{ color: `#303030` }}
                            className="text-truncate d-block m-0 text-muted fw-medium"
                          >
                            {object?.location}
                          </p>
                        </div>

                        <u
                          className="fw-semibold small fs-6"
                          style={{ color: `#ACACAC` }}
                        >
                          <NavLink
                            style={{ color: `#ACACAC`, cursor: `pointer` }}
                            to={`/job-description/job_posting/${object?.id}`}
                          >
                            More details
                          </NavLink>
                        </u>
                      </div>

                      <CustomCheckbox
                        checked={selected.some((item) => item.id === object.id)}
                        id={"check_" + object.id}
                        onChange={() => this.onSelect(object)}
                        style={{ cursor: `pointer` }}
                      />
                    </div>
                  </Card>
                </div>
              ))
            ) : (
              <div className="col text-center text-muted mt-3 w-100 fw-bold fs-5 p-5">
                No results found
              </div>
            )}
          </div>

          <button
            className={`position-fixed btn text-white rounded-5 ps-5 pe-5 fw-bold fs-6 py-3 ms-auto ${
              isChecked ? "d-block" : "d-none"
            }`}
            style={{
              backgroundColor: "#D18237",
              bottom: `5%`,
              left: `50%`,
              transform: `translate(-50%,-50%)`,
            }}
            onClick={this.onclickApplyNow.bind(this)}
          >
            Apply Now
          </button>
        </div>
      </>
    );
  }
}

export default withRouter(JobPortalListPage);
